import { Grid, TextField } from "@mui/material";
import styled from "styled-components";
import { topBarSize, leftBarSize } from "../../../Components/NavBar/styles";
import PasswordInput from "../../Patients/Create/PasswordInput";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { styled as styledMUI } from "@mui/system";
import {
  DeleteForever as DeleteForeverIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import CustomSelection from "../../../Components/CustomSelection";
import CustomSelection2 from "../../../Components/CustomSelection2";

export const Container = styled.div`
  position: absolute;
  top: calc(${topBarSize});
  left: calc(${leftBarSize});

  width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
  height: calc(100% - calc(${topBarSize} + 2rem)) !important;

  padding-top: 1rem;
  padding-left: 1rem;

  z-index: 1;
`;

export const Title = styled.p`
  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 900;
  color: rgba(55, 73, 87, 0.7);
  font-size: 2rem;

  z-index: 2;

  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
`;

export const Button = styled.button`
  position: absolute;
  right: 0%;

  height: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;

  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 900;
  color: #2e933c;

  background: none;
  border: 2px solid #2e933c;
  border-radius: 20px;

  cursor: pointer;

  &:hover {
    background: rgba(55, 73, 87, 0.1);
    transition-duration: 0.1s;
  }

  &:active {
    background: rgba(55, 73, 87, 0.2);
    transition-duration: 0.1s;
  }

  z-index: 3;
`;

export const BackButton = styled.div`
  position: absolute;
  right: 0%;

  height: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;

  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 400;
  color:rgb(255, 0, 0);

  background: none;
  border: 2px solid rgb(255, 0, 0);
  border-radius: 20px;

  cursor: pointer;

  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;    

  &:hover {
    background: rgba(55, 73, 87, 0.1);
    transition-duration: 0.1s;
  }

  &:active {
    background: rgba(55, 73, 87, 0.2);
    transition-duration: 0.1s;
  }

  z-index: 3;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 80%;

  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  border-radius: 10px;
  padding: 5px !important;
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);

  overflow: hidden;
`;

export const ContentTitle = styled(Title)`
  color: rgba(55, 73, 87, 1);
  font-size: 1.6rem;
  padding-left: 1rem;
  text-transform: none;
  margin-bottom: 1rem;
`;

export const ContentBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 1rem;

  flex: 1;
  min-height: 0;
`;

export const ContentBodyLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-right: 1rem;
  overflow-y: auto;
`;

export const ContentBodyRight = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-left: 1rem;
  padding-top: 1rem;
`;

export const ContentInput = styled(TextField)`
  margin-top: 0 !important;
  width: 100%;

  & .MuiFormLabel-root {
    color: gray;
    font-size: 0.875rem;
    font-weight: 500;

    &.Mui-focused {
      color: gray;
    }
  }

  & .MuiInput-underline::after {
    border-bottom-color: #2E933C;
  }
`;

export const ContentInputPassword = styled(PasswordInput)``;

export const ContentInputProfilePhotoIcon = styled(UploadFileIcon)`
  position: absolute;

  top: 50%;
  left: 50%;

  width: 2rem;
  height: 2rem;

  transform: translate(-50%, -50%) scale(4);

  color: rgba(255, 255, 255, 0.5);

  opacity: 1;
`;

export const ContentInputProfilePhoto = styled.div`
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);

  width: 20rem;
  height: 20rem;

  position: relative;
  border-radius: 20px;

  opacity: 0.7;

  z-index: 3;

  &:hover {
    opacity: 1;
    cursor: pointer;
    transition: all 0.2s;
  }

  &:active {
    opacity: 0.5;
  }

  & img {
    width: 100%;
    height: 100%;
    border-radius: 20px;
  }
`;

export const VersionList = styledMUI(Grid)({
  marginTop: "1rem",
  paddingLeft: "5%",
  width: "100%",
  gridColumn: "1 / -1",
  
  height: "100%",
  minHeight: 0,
  overflowY: "auto",

  borderRadius: 4,
  overflowX: "hidden",
});

export const VersionContainer = styledMUI(Grid)({
  display: "flex",
  alignItems: "center",
  height: "5rem",
  margin: "1%",
  padding: "1rem",
  borderRadius: "10px",
  boxShadow: "4px 4px 11px 0px rgba(0, 0, 0, 0.5)",
  gap: "1rem",
});

export const VersionTitle = styled.p`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  color: #949aa7;
  font-weight: 600;
  flex-shrink: 0;
`;

export const Version = styled.p`
  margin: 0;
  font-family: "Roboto";
  color: #949aa7;
  font-size: 0.9rem;
  flex: 1;
`;

export const Icon = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid #00000033;
  border-radius: 10px;
  flex-shrink: 0;
`;

export const UsersIcon = styled(CustomSelection)({});
export const SoftwareIcon = styled(CustomSelection2)({});

export const CodeIcon = styled.div`
  border: 1px solid rgb(255, 154, 2);
  border-radius: 20px;
  width: 12rem;
  padding: 7px;
  margin: 10px;

  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;

  color: #374957;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    transition: all 0.1s;
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 0.1s;
  }
`;

export const VersionRight = styled.div({
  display: "flex",
  gap: "0.5rem",
  alignItems: "center",
  justifyContent: "flex-end",
  flexShrink: 0,
});

export const DeleteIcon = styledMUI(DeleteForeverIcon)({
  width: "2.5rem",
  height: "2.5rem",

  color: "#DB3A34",

  ":hover": {
    color: "#db39348b",
    transition: "all 0.2s",
    cursor: "pointer",
  },

  ":active": {
    color: "#db3934c7",
    cursor: "pointer",
  },
});

interface DeletePromptProps {
  show: boolean;
}
export const DeletePrompt = styled.div<DeletePromptProps>({
  display: "flex",
  float: "right",
  alignItems: "center",
  marginLeft: "10px",
  marginRight: "10px",
});

export const DeletePromptYes = styledMUI(CheckCircleIcon)({
  color: "#db3934c7",
  marginLeft: "10px",

  ":hover": {
    color: "#db39348b",
    transition: "all 0.2s",
    cursor: "pointer",
  },

  ":active": {
    color: "#db3934c7",
    cursor: "pointer",
  },
});

export const DeletePromptNo = styledMUI(CancelIcon)({
  color: "#2E933C",
  marginLeft: "5px",

  ":hover": {
    color: "rgb(46, 147, 60,0.5)",
    transition: "all 0.2s",
    cursor: "pointer",
  },

  ":active": {
    color: "rgb(46, 147, 60,0.7)",
    cursor: "pointer",
  },
});

export const ModalContent = styled.div`
  width: 95%;
  height: 80%;
  background-color: ${(props) => props.theme.background};

  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  border-radius: 10px;
  padding: 5px !important;
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`;

export const InputLabel = styled.span`
    color: gray;
    font-size: 0.875rem;
    font-weight: 500;
    display: block;
    margin-bottom: 0.25rem;
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.5rem;
`;

export const FieldLabel = styled(InputLabel)`
    margin-bottom: 0.5rem;
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
`;

export const Tag = styled.div<{ color?: string }>`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.8rem;
    background-color: ${(props) => props.color || '#2E933C'};
    color: white;
    border-radius: 16px;
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 1.2rem;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2rem;
    height: 1.2rem;

    &:hover {
        opacity: 0.8;
    }
`;

export const FolderFieldRowFull = styled.div`
    display: flex;
    gap: 0.5rem;
    width: 100%;
`;

export const InputFieldSimple = styled.input`
    padding: 0.5rem;
    border: 1px solid ${(props) => props.theme.border || '#ddd'};
    border-radius: 4px;
    font-size: 0.875rem;
    font-family: 'Roboto';

    &:focus {
        outline: none;
        border-color: #2E933C;
        box-shadow: 0 0 0 2px rgba(46, 147, 60, 0.1);
    }
`;
